import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Tabs, Tab, StickyCallToAction, Price } from '@grandvisionhq/common';
import { Text, Hr } from '@grandvisionhq/elements';
import { useProductDetailSlots, StickyAside, ProductDetailUsps, ProductDetailDisclaimer, ProductDetailDrawerStack } from '@grandvisionhq/fun-products';
import { DeliveryIndicator } from '@grandvisionhq/shipping';
import { useFeatureToggles } from '@grandvisionhq/state';
import { PDPPriceSection } from '../Components/PDPPriceSection/PDPPriceSection.js';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/inventory';
import '@grandvisionhq/utils';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/analytics';
import '@grandvisionhq/svc-monetate';
import { ProductDetailReviewsDrawerContainer } from '../Components/ProductDetailReviews/ProductDetailReviewsDrawerContainer.js';
import { ProductImageGalleryContainer } from '../Components/ProductImageGallery/ProductImageGalleryContainer.js';
import { ProductLabelTag } from '../Components/ProductLabelTag/ProductLabelTag.js';
import '@grandvisionhq/reviews';
import '@grandvisionhq/carts-v2';
import { LensesDescription } from './components/LensesDescription/LensesDescription.js';
import { LensesProductTitle } from './components/LensesProductTitle/LensesProductTitle.js';
import { LensesStarReview } from './components/LensesStarReview/LensesStarReview.js';
import 'classnames';
import '@grandvisionhq/forms';
import { LensesSpecification } from './components/LensesSpecification/LensesSpecification.js';
import ConfigureContactLenses from './components/ConfigureContactLenses/ConfigureContactLensesContainer.js';
import './components/ConfigureContactLenses/components/PackageQuantity/PriceAside.js';
import { useLensBundle } from './LensBundles/context.js';

const Lenses = ({ addToCartRef , contactLensesConfiguratorConfig , ctaButton , currency , deliveryIndicatorConfig , isSmallScreen , labels , packPrice , clbbPrice , showStickyButton , variant , activeTabIndex , setActiveTabIndex , isCLBBTabSelected ,  })=>{
    var ref3, ref1;
    const { isDeliveryFullDateEnabled  } = useFeatureToggles();
    const { Slots  } = useProductDetailSlots();
    const { hasCLBBSubscriptions  } = useLensBundle();
    const showDeliveryIndicator = !variant.excludedFromCheckout && !isCLBBTabSelected;
    const packPriceDiscount = packPrice === null || packPrice === void 0 ? void 0 : (ref3 = packPrice.discounted) === null || ref3 === void 0 ? void 0 : ref3.value.centAmount;
    const hidePackPriceInStickyCta = React.useMemo(()=>{
        var ref;
        const hasQuantityDiscountItems = Boolean((ref = contactLensesConfiguratorConfig.quantityDiscountItems) === null || ref === void 0 ? void 0 : ref.length);
        return hasQuantityDiscountItems;
    }, [
        contactLensesConfiguratorConfig.quantityDiscountItems
    ]);
    var ref2;
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__main product-detail-lenses"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__image-gallery"
    }, /*#__PURE__*/ React.createElement(ProductImageGalleryContainer, null)), isSmallScreen && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__header--mobile"
    }, /*#__PURE__*/ React.createElement(LensesProductTitle, null), /*#__PURE__*/ React.createElement(LensesStarReview, {
        className: "product-detail__review-snippet"
    })), /*#__PURE__*/ React.createElement("section", {
        className: "product-detail__aside product-detail-lenses__aside",
        "aria-label": `${variant.brand} ${variant.replacementFrequency}`
    }, /*#__PURE__*/ React.createElement(StickyAside, {
        bottomBoundary: ".product-detail-lenses",
        isEnabled: !isSmallScreen
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "mobile-hidden"
    }, /*#__PURE__*/ React.createElement(LensesProductTitle, null), !isSmallScreen && /*#__PURE__*/ React.createElement(LensesStarReview, {
        className: "product-detail__review-snippet"
    })), ((ref1 = variant.tag) === null || ref1 === void 0 ? void 0 : ref1.value) && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__product-tag"
    }, /*#__PURE__*/ React.createElement(ProductLabelTag, null)), packPrice && !isCLBBTabSelected && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PDPPriceSection, {
        className: "product-detail__specification-prices",
        originalPrice: packPrice.value.centAmount,
        discountedPrice: packPriceDiscount,
        discountDescription: variant.discountText,
        discountBadge: variant.discounted,
        bestPrice: variant.bestPrice
    }), Slots.AfterPrice ? /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__after-price-slot"
    }, /*#__PURE__*/ React.createElement(Slots.AfterPrice, null)) : null), clbbPrice && isCLBBTabSelected && /*#__PURE__*/ React.createElement(PDPPriceSection, {
        className: "product-detail__specification-prices",
        originalPrice: clbbPrice,
        discountDescription: variant.discountText,
        discountBadge: variant.discounted,
        bestPrice: variant.bestPrice
    }), variant.excludedFromCheckout && /*#__PURE__*/ React.createElement(Text, null, variant.packageQuantity, ' ', variant.packageQuantity === 1 ? labels.lens : labels.lenses, " ", labels.perBox), !variant.excludedFromCheckout && hasCLBBSubscriptions && /*#__PURE__*/ React.createElement(Tabs, {
        onChange: setActiveTabIndex,
        activeTabIndex: activeTabIndex,
        variant: "secondary",
        "data-t": "subscription-tabs"
    }, /*#__PURE__*/ React.createElement(Tab, {
        label: labels.oneTimeTitle,
        "data-t": "tab-single-purchase"
    }), /*#__PURE__*/ React.createElement(Tab, {
        label: labels.clbbSubscriptionTitle,
        "data-t": "tab-subscription-purchase"
    })), !variant.excludedFromCheckout && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__configuration product-detail-lenses__configuration"
    }, /*#__PURE__*/ React.createElement(ConfigureContactLenses, swcHelpers.extends({}, contactLensesConfiguratorConfig, {
        isCLBBTabSelected: isCLBBTabSelected
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details",
        ref: addToCartRef
    }, showDeliveryIndicator && isDeliveryFullDateEnabled && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details__delivery-indicator"
    }, /*#__PURE__*/ React.createElement(DeliveryIndicator, swcHelpers.extends({}, deliveryIndicatorConfig, {
        view: "text"
    }))), ctaButton, Slots.AfterCTA ? /*#__PURE__*/ React.createElement(Slots.AfterCTA, null) : null, isSmallScreen && showStickyButton && !!variant.price && (hidePackPriceInStickyCta ? /*#__PURE__*/ React.createElement(StickyCallToAction, {
        button: ctaButton
    }) : /*#__PURE__*/ React.createElement(StickyCallToAction, {
        button: ctaButton,
        price: /*#__PURE__*/ React.createElement(Price, {
            value: (ref2 = packPriceDiscount ? packPriceDiscount : packPrice === null || packPrice === void 0 ? void 0 : packPrice.value.centAmount) !== null && ref2 !== void 0 ? ref2 : 0,
            currency: currency,
            centAmount: true,
            type: packPriceDiscount ? 'discount' : 'default'
        }),
        priceSubtitle: labels.perBox
    }))), /*#__PURE__*/ React.createElement(Hr, {
        className: "product-detail__usp-divider"
    }), /*#__PURE__*/ React.createElement(ProductDetailUsps, {
        className: "product-detail__usps"
    }, showDeliveryIndicator && !isDeliveryFullDateEnabled && /*#__PURE__*/ React.createElement(DeliveryIndicator, swcHelpers.extends({}, deliveryIndicatorConfig, {
        view: "usp"
    })))))), /*#__PURE__*/ React.createElement(LensesDescription, {
        className: "product-detail-lenses__description"
    }), /*#__PURE__*/ React.createElement(ProductDetailDisclaimer, {
        className: "product-detail__disclaimer product-detail-lenses__disclaimer"
    }), /*#__PURE__*/ React.createElement(ProductDetailDrawerStack, {
        className: "product-detail__drawer-stack product-detail-lenses__drawer-stack"
    }, /*#__PURE__*/ React.createElement(LensesSpecification, null), /*#__PURE__*/ React.createElement(ProductDetailReviewsDrawerContainer, null)));
};

export { Lenses, Lenses as default };
//# sourceMappingURL=Lenses.js.map
